import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { externalLinksManager, type IExternalLink } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

const EXTERNAL_LINK_MODULE = 'externalLink';

const searchModule = getSearchModule(externalLinksManager);
const dataObjectModule = getDataObjectsModule<IExternalLink>(externalLinksManager);

const externalLinkModuleInstance = merge<unknown>(dataObjectModule, searchModule);
store.registerModule(EXTERNAL_LINK_MODULE, externalLinkModuleInstance);

export { EXTERNAL_LINK_MODULE };
